export default {
  ui: {
    searchQuery: '',
    loadError: false,
    numberOfAjaxCalls: 0
  },
  gifs: {
    searchResultGifs: [],
    selectedGifs: {}
  }
}



// WEBPACK FOOTER //
// ./src/reducers/initialState.js